<template>
    <v-app>
        <div class="divMAOS">
            <gallegos v-if="'gallegos' == $route.params.id" />
            <garcia v-else-if="'garcia' == $route.params.id"/>
            <lopez v-else-if="'lopez' == $route.params.id"/>
            <orona v-else-if="'orona' == $route.params.id"/>
            <castellanos v-else-if="'castellanos' == $route.params.id"/>
            <vazquez v-else-if="'vazquez' == $route.params.id"/>
            <gutierrez v-else-if="'gutierrez' == $route.params.id"/>
            <agonzalezm v-else-if="'a-gonzalez-m' == $route.params.id"/>
            <nava v-else-if="'nava' == $route.params.id"/>
            <plantaAcademica v-else/>
        </div>
    </v-app>
</template>
<script>
import gallegos from '@/components/Conócenos/docentes/gallegos.vue'
import garcia from '@/components/Conócenos/docentes/garcia.vue'
import lopez from '@/components/Conócenos/docentes/lopez.vue'
import orona from '@/components/Conócenos/docentes/orona.vue'
import castellanos from '@/components/Conócenos/docentes/castellanos.vue'
import vazquez from '@/components/Conócenos/docentes/vazquez.vue'
import gutierrez from '@/components/Conócenos/docentes/gutierrez.vue'
import agonzalezm from '@/components/Conócenos/docentes/a-gonzalez-m.vue'
import nava from '@/components/Conócenos/docentes/nava.vue';
import plantaAcademica from '@/components/Conócenos/pagPlantaAcademica';
export default {
    data() {
        return {
            datosTabla: null,
            primerCiclo: [
                {
                    materia: 'Seminario I',
                    creditos: 3,
                },
                {
                    materia: 'Métodos Estadísticos',
                    creditos: 8,
                },
                {
                    materia: 'Manejo de suelo y agua',
                    creditos: 8,
                },
                {
                    materia: 'Investigación I',
                    creditos: 5,
                },
            ],
            segundoCiclo: [
                {
                    materia: 'Agricultura Sustentable',
                    creditos: 8,
                },
                {
                    materia: 'Microbiología de suelos y promotores de crecimiento',
                    creditos: 8,
                },
                {
                    materia: 'Optativa',
                    creditos: 8,
                },
                {
                    materia: 'Optativa',
                    creditos: 8,
                },
                {
                    materia: 'Investigación II',
                    creditos: 5,
                },
            ],
            tercerCiclo: [
                {
                    materia: 'Abonos agrícolas e inocuidad',
                    creditos: 8,
                },
                {
                    materia: 'Manejo orgánico de plagas',
                    creditos: 8,
                },
                {
                    materia: 'Problema especial',
                    creditos: 8,
                },
                {
                    materia: 'Investigación III',
                    creditos: 5,
                },
            ],
            cuartoCiclo: [
                {
                    materia: 'Seminario II',
                    creditos: 3,
                },
                {
                    materia: 'Investigación IV',
                    creditos: 5,
                },
                {
                    materia: 'Producción orgánica sustentable en Invernaderos',
                    creditos: 8,
                },
                {
                    materia: 'Normatividad de la agricultura orgánica',
                    creditos: 8,
                },
            ],
            cursoVerano: [
                {
                    materia: 'Optativa',
                    creditos: 8
                }
            ]
        }
    },
    created() {
        this.datosTabla = this.$route.params.data
    },
    methods: {
        showBorder(item) {
            if (item.name === "Investigación I") {
                return { borderLeft: 'thick solid hsl(0, 100%, 50%)' }
            }
        },
        insertarRuta(ruta) {
            this.$router.push(ruta);
        },
    },
    components: {
        //maos,
        gallegos,
        garcia,
        lopez,
        orona,
        castellanos,
        vazquez,
        gutierrez,
        agonzalezm,
        nava,
        plantaAcademica
    },
}
</script>